import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { JobbComponent } from "~app/features/administration/jobb/jobb.component";
import { JobbService } from "~app/features/administration/jobb/jobb.service";
import { JobbDetailsComponent } from "./jobb-details/jobb-details.component";

@NgModule({
    imports: [
        RaskCommonModule,
        JobbComponent,
        JobbDetailsComponent
    ],
    providers: [JobbService]
})
export class JobbModule { }
